<template>
  <ValidationProvider ref="provider" name="captcha" v-slot="v">
    <div class="frc-captcha" id="friendly-widget"></div>
    <div>
      <small
        v-for="error in v.errors"
        :key="error"
        class="text-danger input-error"
        >{{ error }}</small
      >
    </div>
  </ValidationProvider>
</template>

<script>
import Vue from "vue";
import { ValidationProvider } from "vee-validate";
import { PSFriendlyCaptchaService } from "@/Captcha/services/PSFriendlyCaptchaService";
import { FriendlyCaptchaSettings } from "@/Captcha/models/responses/FriendlyCaptchaSettings.ts";
import { WidgetInstance } from "friendly-challenge";

export default Vue.extend({
  name: "ps-captcha-friendly",
  components: { ValidationProvider },
  data() {
    return {
      friendlyCaptcha: FriendlyCaptchaSettings,
      widget: Object,
    };
  },
  methods: {
    reset() {
      this.widget.reset();
      this.raiseError(this.$texts.captchaSolutionError);
    },
    raiseError(error) {
      this.$refs.provider.applyResult({
        errors: [error],
        valid: false,
        failedRules: {},
      });
    },
    doneCallback(solution) {
      this.$emit("solutionChanged", solution);
      this.$refs.provider.applyResult({
        errors: [],
        valid: true,
        failedRules: {},
      });
    },
    errorCallback(error) {
      this.raiseError(error);
    },
  },
  mounted() {
    PSFriendlyCaptchaService.getCaptcha().then((data) => {
      this.friendlyCaptcha = data;
      const element = document.querySelector("#friendly-widget");
      const options = {
        sitekey: this.friendlyCaptcha.siteKey,
        puzzleEndpoint: this.friendlyCaptcha.dataPuzzleEndpoint,
        doneCallback: this.doneCallback,
        errorCallback: this.errorCallback,
      };
      this.widget = new WidgetInstance(element, options);
      this.raiseError(this.$texts.captchaSolutionError);
    });
  },
});
</script>
